import { BaseStore, PageStore, ControlStore } from '@stores'

type PageStore = /*unresolved*/ any
type ControlStore = /*unresolved*/ any
const renderManagerKey = Symbol('__renderManager');

export default abstract class Activity extends BaseStore {
  public meta: any;
  public pageStore: PageStore;

  // @ts-ignore
  private [renderManagerKey] = new RenderManager();
  public globalConfig?: any;
  public metaFreeze: any;

  constructor(props: any) {
    super(props)
    const { meta, query, history, params, bRunInDesigner } = props
    setMetaFreeze(this, meta);
    if (!bRunInDesigner) {
      this.setGlobalConfig(query)
    }
    this.pageStore = new PageStore({
      bRunInDesigner,
      query,
      params,
      enumData: meta?.enumData,
      userDefines: meta?.userDefines,
      multiData: meta?.multiData,
      permissionsData: meta?.permissionsData,
      history,
      rootStore: this
    })
    this.controlStore = new ControlStore()
  }
  getRenderManager() {
    return this[renderManagerKey];
  }
  setGlobalConfig(query: any) {
    const { closeBeforeRender } = query
    this.globalConfig = new Proxy({ ...(window.__$ynf?.globalConfig), closeBeforeRender }, {
      set: function (_target, property: string) {
        console.error(`Cannot modify ${property}. globalConfig is read-only.`);
        return true; // 阻止写入操作
      },
    });
  }
  addBeforeRender(fn: Function, source: string) {
    this.getRenderManager().addBeforeRender(fn, source, source ? undefined : new Error())
  }
  async onBeforeRender(meta: any) {
    await this.getRenderManager().onBeforeRender(meta)
    setMetaFreeze(this, meta);
  }

}
function setMetaFreeze(rootStore: any, meta: any) {
  rootStore.metaFreeze = { ...meta }
  Object.freeze(rootStore.metaFreeze);
}

class RenderManager {
  private beforeRenderFns: { fn: Function, source?: string }[] = [];
  private currentBeforeRenderFnIndex = -1;
  private TAG = 'RenderManager__';

  addBeforeRender(fn: Function, source?: string, stackError?: Error) {
    if (source) {
      this.beforeRenderFns.push({ fn, source });
    } else {
      const stack = stackError?.stack?.split('\n');
      if (stack) {
        const callerLine = stack[2]; // 第一行是Error对象构造器，第二行是addBeforeRender自身，第三行是调用者
        const match = callerLine.match(/at (.*) \((.*):(\d+):(\d+)\)/); // 假设堆栈跟踪符合常见的"at functionName (filePath:lineNumber:columnNumber)"格式
        if (match) {
          const [, functionName, filePath, lineNumber, columnNumber] = match;
          const source = `${functionName} (${filePath}:${lineNumber}:${columnNumber})`;
          this.beforeRenderFns.push({ fn, source });
        } else {
          console.warn(`${this.TAG}Unable to parse call site information from stack trace.`);
          this.beforeRenderFns.push({ fn });
        }
      } else {
        console.warn(`${this.TAG}Stack trace is unavailable.`);
        this.beforeRenderFns.push({ fn });
      }
    }
  }

  async onBeforeRender(initialMeta: any): Promise<any> {
    let meta = initialMeta;
    let timeLog = this.TAG + 'onBeforeRender'
    console.time(timeLog)
    console.log(`%c【${this.TAG}onBeforeRender】`, 'color: green; font-size:2em')
    for (let i = this.currentBeforeRenderFnIndex + 1; i < this.beforeRenderFns.length; i++) {
      let timeLogItem = this.TAG + 'onBeforeRender' + i
      console.time(timeLogItem)
      const { fn, source } = this.beforeRenderFns[i];
      if (source) {
        console.log(`${this.TAG}Executing before render function from source: ${source}`);
      }
      try {
        const newMeta = await fn(meta);
        if (!newMeta) throw new Error(`return null`); // 某一次执行失败了记录一下
        meta = newMeta;
      } catch (err) {
        console.warn(`${this.TAG}Error executing before render function from source ${source}:`, err);
        continue; // continue executing further methods after an error occurs
      }
      console.timeEnd(timeLogItem);
      this.currentBeforeRenderFnIndex = i;
    }
    console.timeEnd(timeLog);
    return meta;
  }
}
